<template>
  <div class="wapper">
    <el-container style="100%">
      <TicketType @getTicketTypeId="getTicketTypeId"></TicketType>
      <el-main style="margin-left: 10px; background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.phone"
                      placeholder="手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.code"
                      placeholder="编号"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.idNumber"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                      v-model="searchForm.isPassage"
                      placeholder="选择是否通行"
                  >
                    <el-option label="全部通行" value="-1"></el-option>
                    <el-option label="未通行" value="0"></el-option>
                    <el-option label="已通行" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >&nbsp;&nbsp;
                <el-popover
                    placement="bottom"
                    title="批量导入"
                    width="220"
                    trigger="click"
                >
                  <div>
                    <el-upload
                        class="upload-demo"
                        :action="action"
                        :auto-upload="false"
                        :on-change="uploadChange"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <el-button size="small" type="primary"
                      >选择导入模板
                      </el-button
                      >
                    </el-upload>
                    <el-button
                        type="success"
                        @click="download"
                        plain
                        icon="el-icon-download"
                        class="down-template"
                    >下载模板
                    </el-button
                    >
                  </div>
                  <p class="import-text">只能选择 .xls .xlsx 文件</p>
                  <div>
                    <el-button type="success" @click="importData"
                    >开始导入
                    </el-button
                    >
                  </div>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-upload2"
                      slot="reference"
                  >导入
                  </el-button
                  >
                </el-popover>
              </div>
              <div class="uers-right">
                              <span class="btn-r">
                                <el-button type="primary" plain icon="el-icon-plus"
                                           @click="effective">票有效时间同步</el-button>
                                <el-button type="primary" plain icon="el-icon-clear"
                                           @click="effectiveClear">票有效时间清空</el-button>
                              </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="avatar"
                  width="60"
                  label="头像"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :preview-src-list="[scope.row.avatar]"
                        :src="scope.row.avatar"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" width="100" label="姓名" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span><br/>
                  <span>{{ scope.row.sex }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" width="120" label="手机" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="banner" width="150" label="身份证" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span><br/>
                  <span>{{
                      scope.row.province ? (scope.row.province + scope.row.city + scope.row.area) : ''
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="code" width="150" label="码值/编号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.code }}</span><br/>
                  <span>{{ scope.row.idNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="isPassage" width="150" label="通行/日期" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.isPassage == 0 ? "未通行" : "已通行" }}</span><br/>
                  <span>{{ scope.row.signDate }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="effectiveStart"
                  label="有效时间"
                  align="center" width="150"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.effectiveStart }}</span><br/>
                  <span>{{ scope.row.effectiveEnd }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="signDate" width="150" label="创建日期" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import TicketType from "../../../components/ticketing/ticket/TicketType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        name: "",
        idNumber: "",
        code: "",
        isPassage: "-1",
        phone: "",
      },
      ticketTypeId: 0,
      TicketType: [],
      editData: {},
      listShow: true,
      delVisible: false,
      ticketCom_Id: "",
      editShow: false,
      dataList: [],
      projectId: localStorage.getItem("project_Id"),
      multipleSelection: [],
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
    this.getTicketType();
  },
  methods: {
    getChangeType(isPassage) {
      this.searchForm.isPassage = isPassage;
    },
    getTicketTypeId(val) {
      this.ticketTypeId = val;
      this.searchSubmit();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    exportExcel() {
      var search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        isPassage: this.searchForm.isPassage,
        idNumber: this.searchForm.idNumber,
        code: this.searchForm.code,
        phone: this.searchForm.phone,
        ticketTypeId: this.ticketTypeId,
        projectId: localStorage.getItem("project_Id"),
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/Ticket/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
               window.open(res.data.data, '_self');
              this.downloadFile(res.data.data, '导出票.xlsx');
            } else {
              this.$message.error("导出失败");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出失败");
          });
    }, downloadFile(url, fileName) {
      return fetch(url).then((res) => {
        res.fetch(url).then((blob) => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        });
      });
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        isPassage: this.searchForm.isPassage,
        idNumber: this.searchForm.idNumber,
        code: this.searchForm.code,
        phone: this.searchForm.phone,
        ticketTypeId: this.ticketTypeId,
        projectId: localStorage.getItem("project_Id"),
      };
      this.$axios.post("/Ticket/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          outdata.map((v) => {
            let obj = {};
            obj.name = v.名称;
            obj.avatar = v.头像;
            obj.phone = v.手机号;
            obj.code = v.码值;
            obj.groupNo = v.团组;
            obj.company = v.公司;
            obj.idNumber = v.编号;
            obj.idCard = v.身份证;
            ar.push(obj);
          });
          localStorage.setItem("attr", JSON.stringify(ar));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    download() {
      var url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        window.open(url.replace("/api", "/") + "/data/票模板.xlsx");
      } else {
        window.open(
            url.substring(0, url.lastIndexOf("/api")) + "/data/票模板.xlsx"
        );
      }
    },
    setAvatar() {
      if (this.ticketTypeId != "") {
        if (confirm("是否清除票头像")) {
          this.$axios
              .delete(`/Ticket/Avatar/${this.ticketTypeId}`)
              .then((res) => {
                if (res.data.hasError) {
                  this.$message.error(res.data.message);
                } else {
                  this.$message.success("清除成功！");
                  this.getData();
                }
              });
        }
      } else {
        this.$message.error("请选择证件类型");
      }
    },
    importData() {
      if (this.ticketTypeId != "") {
        this.attr = JSON.parse(localStorage.getItem("attr"));
        if (this.attr && this.attr.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$axios
              .put("/Ticket/AddList/" + this.ticketTypeId, this.attr)
              .then((res) => {
                if (res.data.hasError == false) {
                  loading.close();
                  localStorage.setItem("attr", null);
                  this.getData();
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                  loading.close();
                }
              })
              .catch(function () {
                loading.close();
              });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$message.error("请选择票类型");
      }
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    effective() {
      this.$confirm("是否同步票的有效时间？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.put(`/Ticket/effective/${this.projectId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "同步成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消操作"});
          });
    },
    effectiveClear() {
      this.$confirm("是否清空票有效时间？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.put(`/Ticket/effectiveClear/${this.projectId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "清空成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消操作"});
          });
    },
    handleDelete(index, row) {
      this.ticketCom_Id = row.ticketId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/Ticket/${this.ticketCom_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    getTicketType() {
      this.$axios.get("/TicketType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.TicketType = [...res.data.data];
        }
      });
    },
    handleCloseVisible() {
      this.ticketCom_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    TicketType,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
}
</style>